/* tslint:disable */
/* eslint-disable */

/**
 * supportWebappContactForm support-contact-form api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

import { GeneratedApiClient, GeneratedHttpClientConstraints, RequestOptionsConstraint, HttpMethod, AuthStrategy, ShardingStrategy } from "../runtime";

import type {
    AddAttachmentResponse,
    AssertWebformAvailableResponse,
    DeleteAttachmentRequest,
    GetActiveCitiesListResponse,
    GetUserPersonasListResponse,
    SubmitFormRequest,
    StandardRequest,
} from '../models/index';

export interface HttpClientConstraints {
    Auth: AuthStrategy.JWT;
    Sharding: ShardingStrategy.NONE;
    StandardRequest: StandardRequest;
}

export interface UserPersonasListRequest {
    locale: string;
    city_id?: number;
}


class ApiClientClass<THttpClientConstraints extends GeneratedHttpClientConstraints = HttpClientConstraints, TRequestOptions extends RequestOptionsConstraint = never> extends GeneratedApiClient<THttpClientConstraints, TRequestOptions> {
        public activeCitiesList = async (opts?: TRequestOptions): Promise<GetActiveCitiesListResponse>  => {
            return this.httpClient.sendRequest<GetActiveCitiesListResponse>({
                path: '/supportContactForm/activeCities/list',
                service_id: 'support-contact-form',
                subdomain: 'supportwebappcontactform',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
            }, opts);
        }
        public addAttachment = async (files: Record<'file', File>, opts?: TRequestOptions): Promise<AddAttachmentResponse>  => {
            return this.httpClient.sendRequest<AddAttachmentResponse>({
                path: '/supportContactForm/addAttachment',
                service_id: 'support-contact-form',
                subdomain: 'supportwebappcontactform',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                files,
            }, opts);
        }
        public assertWebformAvailable = async (body: object, opts?: TRequestOptions): Promise<AssertWebformAvailableResponse>  => {
            return this.httpClient.sendRequest<AssertWebformAvailableResponse>({
                path: '/supportContactForm/assertWebformAvailable',
                service_id: 'support-contact-form',
                subdomain: 'supportwebappcontactform',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public deleteAttachment = async (body: DeleteAttachmentRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/supportContactForm/deleteAttachment',
                service_id: 'support-contact-form',
                subdomain: 'supportwebappcontactform',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public submitForm = async (body: SubmitFormRequest, opts?: TRequestOptions): Promise<object>  => {
            return this.httpClient.sendRequest<object>({
                path: '/supportContactForm/submitForm',
                service_id: 'support-contact-form',
                subdomain: 'supportwebappcontactform',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public userPersonasList = async (query: UserPersonasListRequest, opts?: TRequestOptions): Promise<GetUserPersonasListResponse>  => {
            return this.httpClient.sendRequest<GetUserPersonasListResponse>({
                path: '/supportContactForm/userPersonas/list',
                service_id: 'support-contact-form',
                subdomain: 'supportwebappcontactform',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
}
// Split class actual prototype and type
export const ApiClient = ApiClientClass;
/**
 * When you use ApiClient class as a type it would include private / protected properties which leads
 * to a situation where 2 sources of the ApiClient are not equal.
 *
 * This situation can happen for example when a library depends on the whole ApiClient and consumer wants to pass
 * in its own ApiClient. That would lead to an error
 *
 * TS2345: Argument of type 'ApiClient<HttpClientConstraints, HttpRequestOpts>' is not assignable to parameter of type 'ApiClient<HttpClientConstraints, never>'.
 *  Property 'apiClientOptions' is protected but type 'GeneratedApiClient<THttpClientConstraints, TRequestOptions>' is not a class derived from 'GeneratedApiClient<THttpClientConstraints, TRequestOptions>'.
 */
export type ApiClient<THttpClientConstraints extends GeneratedHttpClientConstraints = HttpClientConstraints, TRequestOptions extends RequestOptionsConstraint = never> = {
    [Key in keyof ApiClientClass<THttpClientConstraints, TRequestOptions>]: ApiClientClass<THttpClientConstraints, TRequestOptions>[Key];
};
